import { axiosInstance } from './base'

export function fetchAccount (id) {
  return axiosInstance.get(`accounts/${id}/`)
}

export function updateAccount (id, data) {
  return axiosInstance.put(`accounts/${id}/`, data)
}

export function changePassword (data) {
  return axiosInstance.put('change-password/', data)
}
